/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.DialogFlowSession = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The DialogFlowSession model module.
   * @module model/DialogFlowSession
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>DialogFlowSession</code>.
   * @alias module:model/DialogFlowSession
   * @class
   */
  var exports = function() {
    var _this = this;










  };

  /**
   * Constructs a <code>DialogFlowSession</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DialogFlowSession} obj Optional instance to populate.
   * @return {module:model/DialogFlowSession} The populated <code>DialogFlowSession</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('CreatedBy')) {
        obj['CreatedBy'] = ApiClient.convertToType(data['CreatedBy'], 'Integer');
      }
      if (data.hasOwnProperty('FlowTemplateID')) {
        obj['FlowTemplateID'] = ApiClient.convertToType(data['FlowTemplateID'], 'Integer');
      }
      if (data.hasOwnProperty('CurrentMessageID')) {
        obj['CurrentMessageID'] = ApiClient.convertToType(data['CurrentMessageID'], 'Integer');
      }
      if (data.hasOwnProperty('CreationSourceID')) {
        obj['CreationSourceID'] = ApiClient.convertToType(data['CreationSourceID'], 'Integer');
      }
      if (data.hasOwnProperty('StartDate')) {
        obj['StartDate'] = ApiClient.convertToType(data['StartDate'], 'Date');
      }
      if (data.hasOwnProperty('EndDate')) {
        obj['EndDate'] = ApiClient.convertToType(data['EndDate'], 'Date');
      }
      if (data.hasOwnProperty('DialogScheduleBatchID')) {
        obj['DialogScheduleBatchID'] = ApiClient.convertToType(data['DialogScheduleBatchID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} CreatedBy
   * @default 0
   */
  exports.prototype['CreatedBy'] = 0;
  /**
   * @member {Integer} FlowTemplateID
   * @default 0
   */
  exports.prototype['FlowTemplateID'] = 0;
  /**
   * @member {Integer} CurrentMessageID
   */
  exports.prototype['CurrentMessageID'] = undefined;
  /**
   * @member {Integer} CreationSourceID
   */
  exports.prototype['CreationSourceID'] = undefined;
  /**
   * @member {Date} StartDate
   */
  exports.prototype['StartDate'] = undefined;
  /**
   * @member {Date} EndDate
   */
  exports.prototype['EndDate'] = undefined;
  /**
   * @member {Integer} DialogScheduleBatchID
   */
  exports.prototype['DialogScheduleBatchID'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


